/* unplugin-vue-components disabled */import { render } from "./ShareChapterWithSelector.vue?vue&type=template&id=e5809b46&ts=true"
import script from "./ShareChapterWithSelector.vue?vue&type=script&lang=ts"
export * from "./ShareChapterWithSelector.vue?vue&type=script&lang=ts"

import "./ShareChapterWithSelector.vue?vue&type=style&index=0&id=e5809b46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__